import { getOpenClose } from './getOpenClose';
import { timeToMinutes } from './timeToMinutes';
import { getNextDay } from './getNextDay';

/**
 * Determines the next time event for a location based on its hours of operation.
 * @param {Hours} hours - The hours of operation for the location.
 * @param {string} currentDay - The current day of the week (e.g., 'monday').
 * @param {string} currentTime - The current time in 'HH:MM AM/PM' format.
 * @returns {string} - Next time event (e.g., "Opens 9:00 AM Mon", "Closes 5:00 PM Mon")
 */
export const getNextTimeEvent = (hours, currentDay, currentTime) => {
	const hoursToday = hours[currentDay];
	if (!hoursToday) return '';

	const [open, close] = getOpenClose(hoursToday);

	// Handle closed status
	if (open === 'Closed' || close === 'Closed') return null;

	const openTime = timeToMinutes(open);
	const closeTime = timeToMinutes(close);
	const currentTimeInMinutes = timeToMinutes(currentTime);

	let statement;
	let time;
	let nextDay;

	if (currentTimeInMinutes < openTime) {
		statement = 'OPENS';
		time = open;
	} else if (currentTimeInMinutes >= closeTime) {
		nextDay = getNextDay(hours, currentDay);
		const [openNextDay] = getOpenClose(hours[nextDay]);
		statement = 'OPENS';
		time = openNextDay;
	} else {
		statement = 'CLOSES';
		time = close;
	}
	return {
		statement,
		time,
		nextDay
	};
};
